import _extends from 'babel-runtime/helpers/extends';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
/* eslint-disable react/prop-types */
/* This is the same as the side nav menu renderer and is going to be replaced with a generic solution */

import React, { PureComponent } from 'react';
import { ProductNav } from '@sitebase/web-shell-kit/es/header-kit/product-nav';
import { ProductNavItem } from '@sitebase/web-shell-kit/es/header-kit/product-nav';

import { publish, subscribe, unsubscribe } from '@wh/message-bus';
import { eventSelected, eventRequested, onCommandSelect } from './message-bus-helpers';

var type = '@sitebase/product-menu';
var activeItemIndex = null;
var activeItemId = null;

var ProductMenuRenderer = function (_PureComponent) {
  _inherits(ProductMenuRenderer, _PureComponent);

  function ProductMenuRenderer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProductMenuRenderer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductMenuRenderer.__proto__ || _Object$getPrototypeOf(ProductMenuRenderer)).call.apply(_ref, [this].concat(args))), _this), _this.updateActiveItemIndex = function (nextActiveItemId) {
      activeItemId = nextActiveItemId;
      var activeItem = _this.props.nodeChildren.find(function (_ref2) {
        var data = _ref2.data;
        return data.id === nextActiveItemId;
      });
      activeItemIndex = _this.props.nodeChildren.indexOf(activeItem);
      _this.forceUpdate();
    }, _this.makeItemOnClick = function (data) {
      return function (e) {
        if (e) e.preventDefault();
        publish(eventRequested(data));
      };
    }, _this.subscriptionId = null, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProductMenuRenderer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.updateActiveItemIndex(activeItemId);
      this.subscriptionId = subscribe(onCommandSelect(function (_ref3) {
        var id = _ref3.id;

        _this2.updateActiveItemIndex(id);

        var _props$nodeChildren$f = _this2.props.nodeChildren.find(function (_ref4) {
          var data = _ref4.data;
          return data.id === id;
        }),
            activeItemData = _props$nodeChildren$f.data;

        publish(eventSelected(activeItemData));
      }));
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.nodeChildren === this.props.nodeChildren) return;
      this.updateActiveItemIndex(activeItemId);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.subscriptionId) unsubscribe(this.subscriptionId);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          nodeChildren = _props.nodeChildren,
          runRenderer = _props.runRenderer;


      return React.createElement(
        ProductNav,
        { activeItemIndex: activeItemIndex },
        nodeChildren.map(function (child, index) {
          var data = child.data;
          var link = data.link,
              id = data.id;

          return React.createElement(
            ProductNavItem,
            _extends({}, link, {
              key: id,
              'data-test-id': type + '.item_' + (id ? '_' + id : index),
              href: link.url,
              active: activeItemId === id,
              onClick: _this3.makeItemOnClick(data)
            }),
            runRenderer(child)
          );
        })
      );
    }
  }]);

  return ProductMenuRenderer;
}(PureComponent);

export default {
  type: type,
  render: function render(_ref5, runRenderer) {
    var children = _ref5.children,
        data = _ref5.data;
    return React.createElement(ProductMenuRenderer, {
      key: 'pih.product-menu',
      'data-test-id': '' + type + (data && data.id ? '_' + data.id : ''),
      nodeChildren: children,
      runRenderer: runRenderer
    });
  }
};
//# sourceMappingURL=product-menu.js.map